export default __webpack_public_path__ + "img/moon-cloud.904aa71.svg";